import { render, staticRenderFns } from "./complaint-reports.vue?vue&type=template&id=5dea4e5c&scoped=true&"
import script from "./complaint-reports.vue?vue&type=script&lang=js&"
export * from "./complaint-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dea4e5c",
  null
  
)

export default component.exports